// Use environment variable if available, otherwise fallback to hardcoded values
const getApiUrl = () => {
  if (process.env.VUE_APP_API_URL) {
    return process.env.VUE_APP_API_URL;
  }
  // Production: use relative /api when same-origin, or VUE_APP_API_URL when API is elsewhere (e.g. Heroku)
  if (process.env.NODE_ENV === 'production') {
    return "/api";
  }
  // Development default
  return "http://localhost:3000/api"; 
};

export const url = getApiUrl();

export default {
    url: getApiUrl(),
};